import { render, staticRenderFns } from "./FiBuKontenblaetterList.vue?vue&type=template&id=2b3e5b06&"
import script from "./FiBuKontenblaetterList.vue?vue&type=script&lang=js&"
export * from "./FiBuKontenblaetterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports